import React, { Component } from 'react';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class FontSection extends Component {
  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Typography" />
        <SectionPageHeader description="Typography shapes how our brand communicates and how readers experience our content. Consistent use of our brand font across all materials reinforces a polished, unified identity." />
        <DesignSection
          title={'YipitData Typeface'}>
          <div className="max-width-container">
            <div className="row">
              <div className="small-12 medium-4">
                <img className="full-width" src="/images/font-kicker.png" />
              </div>
              <div className="small-12 medium-8 row" style={{alignItems:'center'}}>
                <div className="full-width small-padding">
                  <h4><b>{'Roboto'}</b></h4>
                  <h5 className="tiny-bottom-margin"><b>{'Professional & Readable'}</b></h5>
                  <p className="subheading">{`Roboto has a dual nature. It has a mechanical skeleton and the forms are largely geometric. At the same time, the font features friendly and open curves.`}</p>
                  <p className="tiny-bottom-margin"><span>{'These fonts are licensed under the '}</span><a target="_blank" href="https://scripts.sil.org/cms/scripts/page.php?site_id=nrsi&id=OFL">{'Open Font License'}</a>{'.'}</p>
                  <div className="row">
                    <div style={{marginRight:10}}>
                      <a href="/design/roboto.zip" download>
                        <div className="button primary-background white">{'Download Font'}<span className="material-symbols-rounded">download</span></div>
                      </a>
                    </div>
                    <a target="_blank" href="https://fonts.google.com/specimen/Roboto#standard-styles">
                      <div className="button primary-background white">{'View on Google'}<span className="material-symbols-rounded">open_in_new</span></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DesignSection>
        <DesignSection
          title={'Spendhound Typeface'}>
          <div className="max-width-container">
            <div className="row medium-bottom-margin">
              <div className="small-12 medium-4">
                <img className="full-width" src="/images/spendhound-font-kicker.png" />
              </div>
              <div className="small-12 medium-8 row" style={{alignItems:'center'}}>
                <div className="full-width small-padding">
                  <h4><b>{'Bitter'}</b></h4>
                  <h5 className="tiny-bottom-margin"><b>{'Titles & Headings'}</b></h5>
                  <p className="subheading">{`A "contemporary" slab serif typeface for text, it is specially designed for comfortably reading on any computer or device. The robust design started from the austerity of the pixel grid, based on rational rather than emotional principles.`}</p>
                  <p className="tiny-bottom-margin"><span>{'These fonts are licensed under the '}</span><a target="_blank" href="https://openfontlicense.org/open-font-license-official-text/">{'Open Font License'}</a>{'.'}</p>
                  <div className="row">
                    <div style={{marginRight:10}}>
                      <a href="/design/bitter.zip" download>
                        <div className="button spendhound-primary-background white">{'Download Font'}<span className="material-symbols-rounded">download</span></div>
                      </a>
                    </div>
                    <a target="_blank" href="https://fonts.google.com/specimen/Bitter">
                      <div className="button spendhound-primary-background white">{'View on Google'}<span className="material-symbols-rounded">open_in_new</span></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DesignSection>
      </div>
    );
  }
}
